import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-solid-pen",
  "use": "fi-icon-solid-pen-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"fi-icon-solid-pen\"><path d=\"M301.2 99.8l111 111c4.7 4.7 4.7 12.3 0 17L140.8 499.2 26.7 511.8C11.4 513.5-1.5 500.6.2 485.3l12.7-114.2L284.2 99.8c4.7-4.7 12.3-4.7 17 0zm196.7-25.6l-60.1-60.1c-18.7-18.7-49.1-18.7-67.9 0l-46.1 46.1c-4.7 4.7-4.7 12.3 0 17l111 111c4.7 4.7 12.3 4.7 17 0l46.1-46.1c18.8-18.8 18.8-49.2 0-67.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol